import { useClickAway } from 'ahooks';
import { get } from 'lodash';
import { useRef } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { type HierarchyMenuItem } from '../../types';
import './style.less';

type Props = {
    menus: HierarchyMenuItem[];
    onOperate: (item: HierarchyMenuItem) => void;
    onClickAway?: () => void;
};

export const Menu: React.FC<Props> = ({ menus, onOperate, onClickAway }) => {
    const { $t } = useLocaleStore();
    const containerRef = useRef<HTMLDivElement>(null);

    useClickAway(() => {
        if (onClickAway) onClickAway();
    }, containerRef);

    const handleOperate = (event: React.MouseEvent, item: HierarchyMenuItem) => {
        event.stopPropagation();
        onOperate(item);
    };

    return (
        <div className="hierarchy-menu" ref={containerRef}>
            {menus.map((item) => (
                <div
                    key={item.operation}
                    className="hierarchy-menu__item"
                    onClick={(event) => handleOperate(event, item)}
                >
                    <IconFont name={item.icon} fontSize={16} />
                    <span className="hierarchy-menu__text">{$t((v) => get(v, item.labelKeyPath))}</span>
                </div>
            ))}
        </div>
    );
};
